import { render, staticRenderFns } from "./paymentChannels.vue?vue&type=template&id=6bea505e&scoped=true"
import script from "./paymentChannels.vue?vue&type=script&lang=js"
export * from "./paymentChannels.vue?vue&type=script&lang=js"
import style0 from "./paymentChannels.vue?vue&type=style&index=0&id=6bea505e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bea505e",
  null
  
)

export default component.exports